export default __webpack_public_path__ + "static/emoji_india-0ac31c337002f65bc94cd5f10f215561.svg";